import React, { useState, useEffect } from 'react';
import {
    SelectInput,
    TextInput,
    DateInput,
    SimpleForm,
    Create,
    useNotify,
    useRedirect,
    CardActions,
    ListButton
} from 'react-admin';


const cardActionStyle = {
    zIndex: 2,
    display: 'block',
    marginLeft:10
};

const CreateActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} />
    </CardActions>
);
const CreateHoliday = (props) => {
    const {REACT_APP_API_ENDPOINT} = process.env;
    const [branches, setBranches] = useState([]);
    const notify = useNotify();
    const redirect = useRedirect();

    // Custom API call with rejection handling
    const fetchBranches = async () => {
        try {
            const response = await fetch(REACT_APP_API_ENDPOINT+'/appointment/branches');
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            // Transform API response to SelectInput format
            const branchChoices = data.result.map(branch => ({
                id: branch.id,
                name: `${branch.location} (${branch.city}, ${branch.state})`
            }));
            return branchChoices;
        } catch (error) {
            return Promise.reject('Failed to fetch branches');
        }
    };

    useEffect(() => {
        fetchBranches()
            .then((branchChoices) => {
                setBranches(branchChoices);
            })
            .catch((error) => {
                notify(error, 'error');
            });
    }, [notify]);

    const handleSuccess = () => {
        notify('New holiday has been successfully added!', 'success', { autoHideDuration: 3000 });
        redirect('/appointment/holidays');
    };


    return (
        <div style={{backgroundColor:'white', width:'600px'}}>

            <h2 style={{marginLeft:10}}>Create Holiday</h2>
            <div style={{ width:'600px', margin:'auto'}}>
        <Create  actions={<CreateActions />} {...props} onSuccess={handleSuccess}>
            <SimpleForm>
                {/* Branch Dropdown */}
                <SelectInput
                    source="branch_id"
                    label="Select Branch"
                    choices={branches}
                    optionText="name"
                    optionValue="id"
                    fullWidth
                />

                {/* Holiday Date Field */}
                <DateInput source="holiday_date" label="Holiday Date" fullWidth />

                {/* Holiday Description Field */}
                <TextInput source="description" label="Description" multiline fullWidth />
            </SimpleForm>
        </Create>
            </div>
        </div>
    );
};

export default CreateHoliday;
